import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import type { PreboardingFormType } from '@hygge/shared';
import { Loader2 } from 'lucide-react';

// MVP exposes only the Pre-boarding type; the dropdown is the seam for future
// form types (Offboarding, Surveys, …) per HW-553.
const FORM_TYPE_OPTIONS: { value: PreboardingFormType; label: string }[] = [
  { value: 'PREBOARDING', label: 'Pre-boarding' },
];

interface FormTypeDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: (type: PreboardingFormType) => void;
  isCreating: boolean;
}

export function FormTypeDialog({ open, onOpenChange, onConfirm, isCreating }: FormTypeDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[440px]">
        <DialogHeader>
          <DialogTitle>New form</DialogTitle>
          <DialogDescription>
            Choose a form type to start. You can configure everything else in the builder.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-2 py-2">
          <Label htmlFor="form-type">Form type</Label>
          <Select value="PREBOARDING" disabled>
            <SelectTrigger id="form-type">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {FORM_TYPE_OPTIONS.map((option) => (
                <SelectItem key={option.value} value={option.value}>
                  {option.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <p className="text-xs text-muted-foreground">
            More form types are coming. For now, only Pre-boarding is available.
          </p>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={isCreating}>
            Cancel
          </Button>
          <Button onClick={() => onConfirm('PREBOARDING')} disabled={isCreating}>
            {isCreating && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            Create form
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
